import { Box, ButtonBase, Container, Typography } from "@mui/material";
import LocationFiler from "./location-filter";
import DatesFilter from "./dates-filter";
import RequirementFilter from "./requirement-filter";
import MapViewOption from "./map-view-option";
import { useState } from "react";
import { useAppDispatch } from "store/appHooks";
import { setSearchDates } from "slices/searchListingReducer";
import moment from "moment";
import axios from "axios";
import { getAddressDetails } from "utils/address.util";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { ROUTES } from "constants/routes";
import { postAPICallServer } from "utils/axios.util";
import { getCartCache, setCartCache } from "utils/cart.util";

const SearchFilters = () => {
  const dispatch = useAppDispatch();
  const [query] = useSearchParams();
  const queryPlace = query.get("place");
  const queryPlaceId = query.get("place_id");
  const dates = query.get("dates");
  const splittedDates = dates ? dates.split("--") : null;

  const [localState, setLocalState] = useState<any>({
    location: {
      description: queryPlace ?? "",
      place_id: queryPlaceId ?? "",
    },
    dates: {
      ...(splittedDates
        ? {
            start: splittedDates[0],
            end: splittedDates[1],
          }
        : {}),
    },
  });
  const navigate = useNavigate();

  const applySearch = async () => {
    if (Object.keys(localState?.dates).length > 0) {
      dispatch(
        setSearchDates({
          start: moment(localState?.dates?.start).format("yyyy-MM-DD"),
          end: moment(localState?.dates?.end).format("yyyy-MM-DD"),
        })
      );
    }
    let latLng = null;
    let placeName = "";
    let placeId = localState?.location?.place_id;

    if (localState?.location?.place_id) {
      const place = localState?.location;
      try {
        const details = await postAPICallServer(`/search/placedetails`, {
          place_id: place.place_id,
        });
        const { data } = details;
        const formated = getAddressDetails(data?.data);
        latLng = `${formated.latitude}~${formated.longitude}`;
        placeName = data?.data?.name ?? "";
      } catch (e) {
        console.log(e);
        latLng = `41.8781136~-87.6297982`;
        placeName = "Chicago, IL, USA";
        placeId = "ChIJD7fiBh9u5kcRYJSMaMOCCwQ";
      }
    }

    const req = query.get("requirement");
    const params = new URLSearchParams({
      ...(req ? { requirement: req } : {}),
      ...(latLng ? { l: latLng } : {}),
      ...(placeName ? { place: placeName } : {}),
      ...(placeId ? { place_id: placeId } : {}),
      ...(Object.keys(localState?.dates).length > 0
        ? {
            dates: `${moment(localState?.dates?.start).format(
              "yyyy-MM-DD"
            )}--${moment(localState?.dates?.end).format("yyyy-MM-DD")}`,
          }
        : {}),
    });

    if (Object.keys(localState?.dates).length > 0) {
      const cartCache = getCartCache();
      setCartCache({
        ...(cartCache ? cartCache : {}),
        from_date: moment(localState?.dates?.start).format("yyyy-MM-DD"),
        to_date: moment(localState?.dates?.end).format("yyyy-MM-DD"),
      });
    }
    navigate(
      `${ROUTES.SEARCH_LISTING}?${params ? `${params.toString()}` : ``}`
    );
  };

  return (
    <Box
      sx={{
        borderBottom: {
          sm: "0px solid #E2E2E2",
          xs: "0px solid #E2E2E2",
          md: "1px solid #E2E2E2",
          lg: "1px solid #E2E2E2",
          xl: "1px solid #E2E2E2",
        },
        px: "3%",
        py: "15px",
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            lg: "repeat(2, 1fr)",
            xl: "repeat(2, 1fr)",
            md: "repeat(2, 1fr)",
            sm: "repeat(1, 1fr)",
            xs: "repeat(1, 1fr)",
          },
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              lg: "repeat(3, 300px)",
              xl: "repeat(3, 340px)",
              md: "repeat(3, 200px)",
              sm: "repeat(1, 100%)",
              xs: "repeat(1, 100%)",
            },
            gap: "20px",
          }}
        >
          <LocationFiler
            onChange={(val: any) =>
              setLocalState({ ...localState, location: val })
            }
            value={localState.location}
          />
          <DatesFilter
            onChange={(vals: any) =>
              setLocalState({ ...localState, dates: vals })
            }
            values={localState.dates}
          />
          {/* <RequirementFilter /> */}
          <ButtonBase
            sx={{
              backgroundColor: "#6E8C20",
              height: "64px",
              width: "64px",
              borderRadius: "10px",
              display: {
                xs: "none",
                sm: "none",
                md: "flex",
                lg: "flex",
                xl: "flex",
              },
            }}
            onClick={applySearch}
          >
            <img src="/assets/img/icons/search_w.svg" alt="" />
          </ButtonBase>

          <ButtonBase
            sx={{
              backgroundColor: "#6E8C20",
              height: "64px",
              width: "100%",
              borderRadius: "10px",
              display: {
                xs: "flex",
                sm: "flex",
                md: "none",
                lg: "none",
                xl: "none",
              },
            }}
            onClick={applySearch}
          >
            <Typography sx={{ fontSize: "15px", color: "#FFF" }}>
              Search
            </Typography>
          </ButtonBase>
        </Box>

        <Box
          sx={{
            gap: "20px",
            flexDirection: "row",
            display: {
              xs: "none",
              sm: "none",
              md: "flex",
              lg: "flex",
              xl: "flex",
            },
            justifyContent: "flex-end",
            // width: "100%",
          }}
        >
          <MapViewOption />
        </Box>
      </Box>
    </Box>
  );
};

export default SearchFilters;
